module.exports = __webpack_public_path__ + "static/img/emotions1_07.21cc7f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/images/emotions1_07.png
// module id = Smiw
// module chunks = 0